import { render, staticRenderFns } from "./UpdateIndex.vue?vue&type=template&id=6fec92fc&scoped=true&"
import script from "./UpdateIndex.vue?vue&type=script&lang=js&"
export * from "./UpdateIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fec92fc",
  null
  
)

export default component.exports